module.exports = "<div class=\"c-payment__request\">\n    <div id=\"payment-request-button\"></div>\n    <p class=\"c-payment__request__text\"><span>Or enter your payment details below</span></p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/journey-ui/payment/views/payment.requestButton.html
// module id = 346
// module chunks = 0